import { createRoute, useParams } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { UserDetailView } from "@/features/admin/components/user-detail/user-detail-view";
import { PageContainer } from "@/components/ui/page-container";

function AdminUserDetailPage() {
  const params = useParams({ from: "/u/$u/admin/users/$userId" });
  return (
    <PageContainer maxWidth="4xl">
      <UserDetailView userId={params().userId} />
    </PageContainer>
  );
}

export const adminUserDetailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/users/$userId",
  component: AdminUserDetailPage,
});
